import React from "react";
import { NavLink } from "react-router-dom";

function Post(props) {
  const imageArray = new Uint8Array(props.post.image.data.data);
  let str = "";
  for (let i = 0; i < imageArray.length; i++) {
    str += String.fromCharCode(imageArray[i]);
  }
  const base64String = btoa(str);
  return (
    <div className="flex h-full w-[300px] flex-col my-2 mx-2 border border-gray-300 rounded-3xl p-2 items-center justify-center">
      <img
        style={{ objectFit: "cover", height: "200px", width: "260px" }}
        src={`data:mimeType;base64,${base64String}`}
        alt="postimage"
      />
      <h1
        className="font-semibold w-44 h-24 text-xl overflow-hidden text-center"
        style={{
          whiteSpace: "normal",
          wordWrap: "break-word",
          maxHeight: "3.2em",
          lineHeight: "1.6em",
        }}
      >
        {props.post.title}
      </h1>
      <p
        className="h-24 overflow-hidden text-sm text-center"
        style={{ whiteSpace: "normal", wordWrap: "break-word" }}
      >
        {props.post.description}
      </p>
      <span className="text-background block mt-2 text-center">
        {props.post.date}
      </span>
      <span className="text-secondary mt-2 text-center">
        By Digital Mechanic
      </span>
      <NavLink to={`/post/${props.post._id}`}>
        <button className="bg-primary text-white p-2 rounded-lg w-[280px] mt-2">
          Read More
        </button>
      </NavLink>
    </div>
  );
}

export default Post;
